import { library } from '@fortawesome/fontawesome-svg-core';

import { faTimesCircle, faCheckCircle, faThumbsUp, faFrown } from '@fortawesome/free-regular-svg-icons';

import {
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faCheck,
  faLock,
  faFire,
  faBurn,
  faSnowflake,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

const allIcons = [
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faTimesCircle,
  faCheck,
  faCheckCircle,
  faLock,
  faFire,
  faBurn,
  faSnowflake,
  faThumbsUp,
  faFrown,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
];

export const addIconsToLibrary = () => allIcons.forEach((icon) => library.add(icon));
